module.exports = __webpack_public_path__ + "img/CS-Lite-Plus_SpareA_1.f2f06eed.jpg";